export const getUrlHostName = (appUrl: string) => {
  const hostParts = new URL(appUrl).host.split('.')
  return hostParts.length > 2
    ? hostParts.slice(-3).join('.')
    : hostParts.join('.')
}
export const appUrl = (path?: string) => {
  const config = useRuntimeConfig()
  return config.public.appUrl + (path || '')
}

export default getUrlHostName
